<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title v-if="!temp_id">{{ 'Add equipment template' | translate }}</v-card-title>
              <v-card-title v-if="temp_id">{{ 'Edit equipment template' | translate}}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                    <v-row>
                        <v-col cols="12" sm="8" md="8">
                            <v-row v-if="errors">
                                <v-col cols="12" sm="12" md="12">
                                <v-alert
                                    dense
                                    v-for="(v, k) in errors"
                                    :key="k"
                                    outlined
                                    type="error"
                                >{{ k }} {{ v }}</v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                        outlined
                                        :label="'Template name' | translate"
                                        v-model="temp_name"
                                        name="temp_name"
                                        autocomplete="off"
                                        :rules="templatenameRules"
                                        required
                                    >
                                    <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>                            
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                        outlined
                                        :label="'Validity' | translate"
                                        v-model="temp_validity"
                                        name="temp_validity"
                                        autocomplete="off"
                                        :rules="tempvalidityRules"
                                        type="number"
                                        min='1'
                                        required
                                    >
                                    <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>                            
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row v-if="temp_id  != null ">
                                <v-col cols="12" sm="6">
                                    <div class="pb-4 title">{{ 'Equipment Templates' | translate}}</div>
                                </v-col>
                                <v-col cols="12" sm="6" style="text-align:right;">
                                    <v-btn small class="white--text" :color="primary_color" @click="openAddEditTemplateBox()" >{{ 'Add document'| translate }}</v-btn>
                                </v-col>
                                <v-divider></v-divider>
                            </v-row>
                            <v-row v-if="temp_id != null ">
                                <v-col cols="12">
                                    <v-data-table
                                    :headers="equipmenttemplateheaders"
                                    :search="search"
                                    :items="templateDocuments"
                                    item-key="doc_id"
                                    class="elevation-1"
                                    :footer-props="{ 'items-per-page-text': footertext, 'itemsPerPageOptions':[5,10,20,{ text: $t('All'), value: -1 }]   }"
                                    >
                                    <template v-slot:top>
                                    <v-card-title>
                                        <v-spacer></v-spacer>
                                    </v-card-title>
                                    <v-toolbar flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-text-field  v-model="search" append-icon="search" :label="'Search' | translate" single-line hide-details></v-text-field>
                                    </v-toolbar>       
                                    </template> 

                                    <template slot="no-data">
                                        {{ 'No data available' | translate }}
                                    </template>
                                    <template v-slot:footer.page-text="items"> 
                                        {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
                                    </template> 
                                    <template v-slot:item.template ="{ item }" >
                                        <v-icon
                                            small
                                            class="mr-2"
                                            v-on:click="previewTemplate(item.temp_file_id)"
                                        >mdi-eye</v-icon>
                                        <v-icon
                                            small
                                            class="mr-2"
                                            v-if="item.status == 'active'"
                                            v-on:click="openeditTemplateBox(item)"
                                        >edit</v-icon>
                                    </template>                        
                                    </v-data-table>                          
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                        </v-col>
                    </v-row>
                </v-form>
                <v-btn
                dark
                fab
                fixed
                bottom
                right
                large
                color="pink"
                class="mx-2"
                v-if="temp_id == null"
                @click="submit"
                >
                <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                dark
                fab
                fixed
                bottom
                right
                large
                color="pink"
                class="mx-2"
                v-if="temp_id"
                @click="update"
                >
                <v-icon>mdi-content-save</v-icon>
                </v-btn>
                </v-card-text>
            </v-container>
          </v-card>
       </v-col>
      </v-row>
      <TemplateBox
        v-if="addCertificationDialog"
        :addCertificationDialog="addCertificationDialog"
        @closeTemplateBox="closeTemplateBox"
        @addCustomLabel="addCustomLabel"
        :dragDropValues="dragDropValues"
        :key="addCertificationDialog"
        :temp_id="temp_id"
        :previewSlug="'all-templates/preview'"
        :updateSlug="'templates/equipment'"
        :getData="getData"
        :temp_validity="temp_validity"
        :editSlug="'templates/equipment/view-file/'"
        :editTemplate="editValues"
        :title="templateEditTitle"
       />
    </v-container>
  </v-content>
</template>  
<script>
import {
  ADD_EQUIPMENT_TEMPLATE_DATA,
  FETCH_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA,
  DOWNLOAD_EQUIPMENT_TEMPLATE_DOCUMENT,
  UPDATE_EQUIPMENT_TEMPLATE_DATA,
  RESET_STATE,
} from "@/store/actions.type";
import {  SET_LOADING, SET_SNACKBAR, SET_ROUTER_ENTER} from "@/store/mutations.type"
import mixins from "@/mixins/mixins"
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"
export default {
    name: "addeditCalibrationTemplate",  
    mixins: [mixins], 
    async beforeRouteEnter(to, from, next) {
        await store.dispatch(RESET_STATE)
        if (to.params.id) {
        await store.dispatch(FETCH_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA, to.params.id).then(resp => {
        if (resp.success) {
            store.commit(SET_LOADING, false)
            store.commit(SET_ROUTER_ENTER, false)
        }
        });
        }
        return next();
    },
    data: function(){
        return {
            temp_name: null,
            temp_id: null,
            temp_validity: null,
            filename: null,
            file: null,
            dialog: false,
            search: '',
            primary_color:null,
            editValues: {},
            addCertificationDialog: false,
            editTemplate: false,
            temp_file: null,
            dragDropValues:[],
            templateEditTitle: 'Add template',
            getData: FETCH_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA,
        }
    },
    components : {
        TemplateBox: () => import("@/components/custompdf/custompdf"),
    },
    computed: {
        ...mapGetters(['curLanguage', 'currentUser','individualequipmenttemplate']),
        ...mapState({
        errors: state => state.equipmenttemplate.equipmenttemplateerrors
        }),
        templateDocuments(){
            return this.individualequipmenttemplate.temp_files
        },
        templatenameRules(){  return [v => !!v || "Template name is required"]},
        tempvalidityRules(){  return [v => !!v || "Validity is required"]},
        templatefileRules(){ 
            return [
                v => !!v || 'Template file is required',
                 
            ]
        },
        equipmenttemplateheaders(){
            return [
                { text: this.$t("Equipment template id"), value: "temp_id" },  
                { text: this.$t("Status"), value: "status" },  
                { text: this.$t("View"), value: "template" }
            ]
        },
        footertext(){
        return this.$t('Rows per page')
        },          
        
    },
    watch:{
        filename(newValue){
            if(newValue == null){
                this.file = null
                this.filename = null
            }
        }
    },
    created(){
        if(!this.hasrequiredPermissions()){
            this.$router.push('/dashboard');
        }
    },
    mounted () {
        if(Object.keys(this.individualequipmenttemplate).length > 0) {
            this.temp_name = this.individualequipmenttemplate.temp_name
            this.temp_id = this.individualequipmenttemplate.temp_id
            this.temp_validity = this.individualequipmenttemplate.temp_validity
            let company_meta  = JSON.parse(this.currentUser.company.company_meta)
            this.primary_color  = company_meta.primary_color 
            this.dragDropValues = JSON.parse(this.individualequipmenttemplate.drag_meta_data)
        }
    },
    methods:{
        hasrequiredPermissions(){
            if(JSON.parse(this.currentUser.company.company_meta).has_equip_db == "true" && (this.currentUser.roles.includes(1) == true || this.currentUser.roles.includes(3) == true || this.currentUser.permissions.includes('can-create-equipment-template') || this.currentUser.permissions.includes('can-update-equipment-template') )){
                return true;
            }
            return false;
        },
        openeditTemplateBox(item) {
            this.editValues = item
            this.templateEditTitle = 'Edit equipment template'
            this.addCertificationDialog = true
        },
        previewTemplate(id){
            this.handlePreview('all-templates/preview',id)
        },
        closeBox(){
            this.file = null
            this.filename =null
            document.getElementById("documentform").reset();
            this.dialog = false
        },
        openAddEditTemplateBox(){
            this.addCertificationDialog = true
        },
        closeTemplateBox () {
            this.editValues = {}
            this.templateEditTitle = 'Add template'
            this.editTemplate = false
            this.addCertificationDialog = false
        },
        async updateDocument(){
            var documentformData = new FormData(document.getElementById("documentform"));
            documentformData.set("temp_name", this.individualequipmenttemplate.temp_name);
            documentformData.set("temp_validity", this.individualequipmenttemplate.temp_validity);
            documentformData.set("temp_id", this.temp_id);
            documentformData.set("_method", "put");
            if (this.file != null) {
                documentformData.append("temp_files", this.file);
            }
            this.$store.dispatch(UPDATE_EQUIPMENT_TEMPLATE_DATA, documentformData).then(resp => {
                if (resp.success) {
                    this.$store.dispatch(FETCH_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA, this.individualequipmenttemplate.temp_id).then(resp=>{
                        if(resp.success){
                            this.$store.commit(SET_SNACKBAR, {status: true, message: 'Equipment template updated successfully'})
                            this.file = null
                            this.filename =null
                            this.closeBox();
                        }
                    })
                }
            }); 
        },
        async downloadTemplate(documentdata){
        await this.$store
            .dispatch(DOWNLOAD_EQUIPMENT_TEMPLATE_DOCUMENT, 'view-file/'+documentdata.temp_file_id)
            .then(resp => {
                this.downloadDocument(this.individualequipmenttemplate.temp_name, resp,documentdata)
                this.$store.commit(SET_LOADING, false);

            });
        },
        onFileSelected() {
        this.file = document.getElementById("template_file_id").files[0];
        }, 
        submit(){
            if (this.$refs.form.validate()) {
                var formData = new FormData(document.getElementById("form"));
                if (this.file != null) {
                    formData.append("temp_files", this.file);
                }
                this.$store.dispatch(ADD_EQUIPMENT_TEMPLATE_DATA, formData).then(resp => {
                if (resp.success) {
                    this.$store.commit(SET_SNACKBAR, {status: true, message: 'Equipment template added successfully'})
                    this.file = null
                    this.filename =null
                    this.$router.push({
                    name: "Calibrationtemplate",
                    });
                }
                });            
                
            }
        },
        addCustomLabel(item){
            this.dragDropValues = [ ...item ]
            this.editTemplate = true
            this.update()
        },
        update(){
            if (this.$refs.form.validate()) {
                var formData = new FormData(document.getElementById("form"));
                if (this.file != null) {
                    formData.append("temp_files", this.file);
                }
                formData.set("temp_id", this.temp_id);
                formData.set("temp_file_id",this.individualequipmenttemplate.temp_files[0] != undefined ? this.individualequipmenttemplate.temp_files[0].temp_file_id: '')
                formData.set("drag_meta_data",JSON.stringify(this.dragDropValues))
                formData.set("_method", "put");

                this.$store.dispatch(UPDATE_EQUIPMENT_TEMPLATE_DATA, formData).then(resp => {
                    if (resp.success && this.editTemplate == false) {
                        this.$store.commit(SET_SNACKBAR, {status: true, message: 'Equipment template updated successfully'})
                        this.file = null
                        this.filename =null
                        this.$router.push({
                        name: "Calibrationtemplate",
                        });
                    }

                    if(this.editTemplate){
                        this.dragDropValues = JSON.parse(resp.data.drag_meta_data)
                        this.$store.dispatch(FETCH_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA, this.temp_id)
                    }
                });            
                
            }
        }
    }
}
</script>
<style lang="scss">
.v-data-footer {
  -webkit-box-pack: start !important;
  -ms-flex-pack: start !important;
  justify-content: flex-start !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}

.v-application--is-ltr .v-data-footer__select {
  margin-left: 16px !important;
}
</style>